var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVixyLogoRgb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 208.03 111.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m84.1,8.11c0,4.48-3.64,8.11-8.12,8.11s-8.12-3.63-8.12-8.11,3.64-8.11,8.12-8.11,8.12,3.63,8.12,8.11Zm108.97,20.69l-15.62,40.9-13.06-34.19c-1.52-3.97-5.39-6.64-9.65-6.64h-18.31c-3.38,0-6.54,1.65-8.47,4.42l-8.94,12.83-12.07-17.32h-16.66l20.6,29.57-10.03,14.39c-.48.69-1.27,1.11-2.12,1.11h-13.18c-1.43,0-2.58-1.16-2.58-2.58v-32.09c0-5.7-4.62-10.33-10.33-10.33h-19.35c-4.25,0-8.13,2.67-9.65,6.64l-13.06,34.19L14.97,28.8l-14.97.05,22.54,59.01h16.1l16.55-43.34c.38-1,1.34-1.66,2.41-1.66h8.8c1.42,0,2.58,1.16,2.58,2.58v32.09c0,5.7,4.62,10.33,10.33,10.33h22.3c3.38,0,6.54-1.65,8.48-4.43l8.94-12.83,12.04,17.28h16.66l-20.57-29.52,10.03-14.39c.48-.69,1.27-1.11,2.12-1.11h11.14c1.07,0,2.03.66,2.41,1.66l17.03,44.59-.86,2.06c-1.77,4.4-4.61,6.65-8.43,6.71-.11,0-.21,0-.31,0-1.17-.03-2.37-.3-3.21-.74-.87-.46-2.15-1.25-3.55-2.5l-5.05,13.68c.78.5,1.49.9,2.1,1.22,2.78,1.46,6.04,2.27,9.42,2.34.17,0,.33,0,.51,0,.09,0,.19,0,.28,0,9.6-.14,17.34-5.78,21.21-15.4l2.78-6.67.19-.49,23.09-60.45-14.96-.07Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVixyLogoRgb);
export default __webpack_public_path__ + "static/media/VIXY_Logo_RGB.a9530716df4ae0b936b85e89f1555f87.svg";
export { ForwardRef as ReactComponent };